import { EyeOutlined } from '@ant-design/icons'

import { pick } from '@eastcoal/common/utils/object'

import { useRichEditorStore } from '../../../../Store/hooks/useStore'
import { MenuButton } from '../../../MenuButton'
import { useAttachmentCardStore } from '../../Store/hooks/useStore'

export const PreviewAttachmentButton = () => {
  const previewFileRef = useRichEditorStore(state => state.previewFileRef)
  const { ossId, ossUrl, filename, mimeType } = useAttachmentCardStore(state =>
    pick(state, ['ossId', 'ossUrl', 'filename', 'mimeType'])
  )

  const handlePreview = () => {
    previewFileRef.current?.open({
      ossId,
      url: ossUrl,
      name: filename,
      type: mimeType
    })
  }

  return (
    <MenuButton alwaysEnabled tooltip='预览' onClick={handlePreview}>
      <EyeOutlined />
    </MenuButton>
  )
}
